import { Routes, Route } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import { Layout } from './components/layout/Layout'
import {
  HomePage,
  ClusterBrowserPage,
  ClusterDetailPage,
  ProteinViewerPage,
  BlastSearchPage,
  ReactionSearchPage,
  SubstructureSearchPage,
  NotFoundPage,
  FujisanHitsPage,
  UnkaiHitsPage,
} from './pages'
import { DataSourcesPage } from './pages/DataSourcesPage'
import { PdbHitsPage } from './pages/PdbHitsPage'
import { SwissprotHitsPage } from './pages/SwissprotHitsPage'
import { ComplexDetailPage } from './pages/ComplexDetailPage'

function App() {
  return (
    <Layout>
      <AnimatePresence mode="wait">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/clusters" element={<ClusterBrowserPage />} />
          <Route path="/clusters/:clusterId" element={<ClusterDetailPage />} />
          <Route path="/clusters/:clusterId/complex/:protein1Id/:protein2Id" element={<ComplexDetailPage />} />
          <Route path="/proteins/:geneId" element={<ProteinViewerPage />} />
          <Route path="/blast" element={<BlastSearchPage />} />
          <Route path="/reactions" element={<ReactionSearchPage />} />
          <Route path="/substructure" element={<SubstructureSearchPage />} />
          <Route path="/data-sources" element={<DataSourcesPage />} />
          <Route path="/proteins/:clusterId/:proteinId" element={<ProteinViewerPage />} />
          <Route path="/proteins/:clusterId/:proteinId/pdb-hits" element={<PdbHitsPage />} />
          <Route path="/proteins/:clusterId/:proteinId/swissprot-hits" element={<SwissprotHitsPage />} />
          <Route path="/proteins/:clusterId/:proteinId/fujisan-hits" element={<FujisanHitsPage />} />
          <Route path="/proteins/:clusterId/:proteinId/unkai-hits" element={<UnkaiHitsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AnimatePresence>
    </Layout>
  )
}

export default App
